<script setup lang="ts">
  import { useForm } from 'vee-validate';
  import FormField from '@/components/form/FormField.vue';

  const chatStore = useChatStore();
  const { handleSubmit, values } = useForm();

  const isSubmitDisabled = computed(() => !values.companyUrl || !values.companyUrl.length);

  const onSubmit = handleSubmit(async (formData: any, { resetForm }) => {
    await chatStore.searchByCompanyUrl(formData.companyUrl);
    resetForm();
    chatStore.closeCompanyUrlModal();
  });
</script>

<template>
  <div class="chat-chameleon modal-container">
    <div class="chat-chameleon-modal">
      <div class="chat-chameleon-modal__wrapper">
        <div class="chat-chameleon-modal__header">
          <div class="chat-chameleon-modal__title">{{ $t('chat.chameleonModal.title') }}</div>
          <a
            class="chat-chameleon-modal__close"
            @click.prevent.stop="chatStore.closeCompanyUrlModal" />
        </div>
        <div class="chat-chameleon-modal__content">
          <p>{{ $t('chat.chameleonModal.text') }}</p>
          <form
            id="chameleonCompanyUrlForm"
            novalidate
            @submit.prevent="onSubmit">
            <FormField
              type="text"
              name="companyUrl"
              :label="$t('chat.chameleonModal.url')" />
          </form>
        </div>
        <div class="chat-chameleon-modal__footer">
          <button
            class="chat-chameleon-modal__btn-confirm"
            type="submit"
            form="chameleonCompanyUrlForm"
            :disabled="isSubmitDisabled">
            {{ $t('chat.chameleonModal.confirm') }}
          </button>
          <button
            class="chat-chameleon-modal__btn-decline"
            @click.prevent.stop="chatStore.closeCompanyUrlModal">
            {{ $t('chat.chameleonModal.decline') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
